const handleYearInputChange = (event: Event): void => {
  const target = event.target as HTMLInputElement
  const form = target.closest('form') as HTMLFormElement
  const formData = new FormData(form)

  const fields = Array.from(formData, ([name, value]) => ({
    name,
    value,
  }))
  const filteredFields = fields.filter(({ name }) => name !== '_method')

  const fiscalYearsSave = document.getElementById('fiscal-years-save')
  const loadingAnimation = document.querySelector('.loading-animation')
  const overlay = document.querySelector('.overlay') as HTMLElement
  const previewUrl = form.getAttribute('data-preview-url')

  if (fiscalYearsSave) {
    fiscalYearsSave.setAttribute('disabled', '')
  }

  if (overlay) {
    overlay.style.display = 'block'
  }

  if (loadingAnimation) {
    loadingAnimation.classList.add('busy')
  }

  if (previewUrl) {
    void $.post(previewUrl, filteredFields).always(function () {
      if (overlay) {
        overlay.style.display = 'none'
      }

      if (loadingAnimation) {
        loadingAnimation.classList.remove('busy')
      }
    })
  }
}

export default (): void => {
  // TODO: Datepicker emits the change JQuery event and is not based on the native change event of the input
  $(document).on(
    'change',
    '[data-behaviour~="fiscal-year-input"]',
    handleYearInputChange
  )
}
